import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ImageLightBoxComponent } from '../../../Dialogs/components/ImageLightBox/image-light-box.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { TemplateCardModel } from '../../model/template-card.model';

@Component({
    selector: 'agpr-template-card',
    templateUrl: './template-card.component.html',
    styleUrls: ['./template-card.component.scss'],
    standalone: false
})
export class TemplateCardComponent {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() template: TemplateCardModel;
    @Input() imagePosition: string = 'top';

    constructor(
        public coreDialogService: CoreDialogService,
        @Inject(APP_BASE_HREF) public appBaseHref: string
    ) {
    }

    public previewImage(previewImageSrc: string): void {
        this.coreDialogService.open(
            ImageLightBoxComponent,
            {
                inputs: {
                    id: this.template.id + '_preview',
                    src: previewImageSrc,
                    width: 400
                }
            }
        );
    }
}
